import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
    connect() {
        $('#mainPageGo').attr('href','index.html?' + usertoken);
    }
}